var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 29,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.564
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M2.449 23.433l-.549.55.547.553 2.204 2.227.553.559.556-.556 10.523-10.534a2.347 2.347 0 00-.005-3.322L5.757 2.445l-.555-.552-.552.555-2.206 2.218-.55.553.551.552 8.819 8.829-8.816 8.833z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.527 23.433l-.549.55.547.553 2.204 2.227.553.559.556-.556 10.523-10.534a2.347 2.347 0 00-.005-3.322L19.836 2.445l-.555-.552-.552.555-2.206 2.218-.55.553.551.552 8.819 8.829-8.816 8.833z"
  })));
}
SvgArrow.displayName = 'Arrow';
export default SvgArrow;